import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/estoques_grupos";

export const Route = createFileRoute("/_authenticated/estoques_grupos")({
  head: () => ({
    meta: [
      { title: "Grupos de estoque — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Cadastro dos grupos de estoque, com nome e descrição, usados para organizar os depósitos.",
      },
      { property: "og:title", content: "Grupos de estoque — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Cadastro dos grupos de estoque, com nome e descrição, usados para organizar os depósitos.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
